var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    [
      _c(
        "v-flex",
        [
          _c(
            "v-tabs",
            {
              model: {
                value: _vm.active,
                callback: function ($$v) {
                  _vm.active = $$v
                },
                expression: "active",
              },
            },
            [
              _c("v-tab", [_c("h6", [_vm._v("Configuration")])]),
              _vm._v(" "),
              _c("v-tab", [_c("h6", [_vm._v("Log Levels")])]),
              _vm._v(" "),
              _c(
                "v-tab-item",
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-title",
                        [
                          _c(
                            "h3",
                            { staticClass: "headline mb-0 admin-header" },
                            [_vm._v("Configuration")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                text: "",
                                icon: "",
                                color: "grey lighten-1",
                              },
                              on: { click: _vm.refreshList },
                            },
                            [_c("v-icon", [_vm._v("fas fa-sync")])],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "primary",
                                outlined: "",
                                rounded: "",
                              },
                              on: { click: _vm.showExtraConfigs },
                            },
                            [_vm._v("Edit Extra Configs")]
                          ),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "primary",
                                outlined: "",
                                rounded: "",
                              },
                              on: { click: _vm.showAllowedTypes },
                            },
                            [_vm._v("Edit Allowed Types")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-dialog",
                            {
                              attrs: { "max-width": "900px" },
                              model: {
                                value: _vm.showExtraConfigsDialog,
                                callback: function ($$v) {
                                  _vm.showExtraConfigsDialog = $$v
                                },
                                expression: "showExtraConfigsDialog",
                              },
                            },
                            [
                              _c(
                                "v-card",
                                [
                                  _c("v-card-title", [
                                    _c("span", { staticClass: "headline" }, [
                                      _vm._v("Extra Configs"),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-card-text",
                                    [
                                      _vm.showExtraConfigsDialog
                                        ? _c("nv-pair", {
                                            attrs: {
                                              input: _vm.extraConfigsString,
                                            },
                                            on: {
                                              cancel: function ($event) {
                                                _vm.showExtraConfigsDialog = false
                                              },
                                              save: _vm.saveExtraConfigs,
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-dialog",
                            {
                              attrs: { "max-width": "900px" },
                              model: {
                                value: _vm.showAllowedTypesDialog,
                                callback: function ($$v) {
                                  _vm.showAllowedTypesDialog = $$v
                                },
                                expression: "showAllowedTypesDialog",
                              },
                            },
                            [
                              _c(
                                "v-card",
                                [
                                  _c("v-card-title", [
                                    _c("span", { staticClass: "headline" }, [
                                      _vm._v("Allowed Types"),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-container",
                                        { attrs: { "grid-list-md": "" } },
                                        [
                                          _c(
                                            "v-layout",
                                            { attrs: { wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                { attrs: { xs12: "" } },
                                                [
                                                  _c("v-select", {
                                                    attrs: {
                                                      items: _vm.allTypeCodes,
                                                      label: "Types",
                                                      multiple: "",
                                                    },
                                                    model: {
                                                      value: _vm.allowedTypes,
                                                      callback: function ($$v) {
                                                        _vm.allowedTypes = $$v
                                                      },
                                                      expression:
                                                        "allowedTypes",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-card-actions",
                                    [
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "mr-4",
                                          attrs: {
                                            color: "primary",
                                            outlined: "",
                                            rounded: "",
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              _vm.showAllowedTypesDialog = false
                                            },
                                          },
                                        },
                                        [_vm._v("Cancel")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "primary",
                                            rounded: "",
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.saveAllowedTypes.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("Save")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: {
                              "append-icon": "fal fa-search",
                              placeholder: "Search",
                              "single-line": "",
                              "hide-details": "",
                              clearable: "",
                            },
                            model: {
                              value: _vm.search,
                              callback: function ($$v) {
                                _vm.search = $$v
                              },
                              expression: "search",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-dialog",
                        {
                          attrs: { "max-width": "600px" },
                          model: {
                            value: _vm.dialog,
                            callback: function ($$v) {
                              _vm.dialog = $$v
                            },
                            expression: "dialog",
                          },
                        },
                        [
                          _c(
                            "v-card",
                            [
                              _c("v-card-title", [
                                _c("span", { staticClass: "headline" }, [
                                  _vm._v("Configuration"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-form",
                                    {
                                      on: {
                                        submit: function ($event) {
                                          $event.preventDefault()
                                        },
                                      },
                                      model: {
                                        value: _vm.valid,
                                        callback: function ($$v) {
                                          _vm.valid = $$v
                                        },
                                        expression: "valid",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-container",
                                        { attrs: { "grid-list-md": "" } },
                                        [
                                          _c(
                                            "v-layout",
                                            { attrs: { wrap: "" } },
                                            [
                                              !_vm.editedItem.type ||
                                              _vm.editedItem.type === "text"
                                                ? _c(
                                                    "v-flex",
                                                    { attrs: { xs12: "" } },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label:
                                                            _vm.editedItem
                                                              .parameter.name,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.editedItem
                                                              .value,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.editedItem,
                                                              "value",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "editedItem.value",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.editedItem.type === "numeric"
                                                ? _c(
                                                    "v-flex",
                                                    { attrs: { xs12: "" } },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label:
                                                            _vm.editedItem
                                                              .parameter.name,
                                                          rules: [
                                                            _vm.rules.numeric,
                                                          ],
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.editedItem
                                                              .value,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.editedItem,
                                                              "value",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "editedItem.value",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.editedItem.type === "boolean"
                                                ? _c(
                                                    "v-flex",
                                                    { attrs: { xs12: "" } },
                                                    [
                                                      _c("v-checkbox", {
                                                        attrs: {
                                                          label:
                                                            _vm.editedItem
                                                              .parameter.name,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.editedItemBooleanValue,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.editedItemBooleanValue =
                                                              $$v
                                                          },
                                                          expression:
                                                            "editedItemBooleanValue",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.editedItem.type === "list"
                                                ? _c(
                                                    "v-flex",
                                                    { attrs: { xs12: "" } },
                                                    [
                                                      _c("v-select", {
                                                        attrs: {
                                                          items:
                                                            _vm.editedItem.options.split(
                                                              ","
                                                            ),
                                                          label:
                                                            _vm.editedItem
                                                              .parameter.name,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.editedItem
                                                              .value,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.editedItem,
                                                              "value",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "editedItem.value",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-card-actions",
                                [
                                  _c("v-spacer"),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "mr-4",
                                      attrs: {
                                        color: "primary",
                                        outlined: "",
                                        rounded: "",
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.close.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Cancel")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { color: "primary", rounded: "" },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.save.apply(null, arguments)
                                        },
                                      },
                                    },
                                    [_vm._v("Save")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-data-table",
                        {
                          staticClass: "elevation-1",
                          attrs: {
                            headers: _vm.headers,
                            items: _vm.filteredConfigs(),
                            search: _vm.search,
                            loading: _vm.loading,
                            options: _vm.pagination,
                            "item-key": "parameter.key",
                          },
                          on: {
                            "update:options": function ($event) {
                              _vm.pagination = $event
                            },
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "item.actions",
                              fn: function ({ item }) {
                                return [
                                  _c(
                                    "td",
                                    { staticClass: "actions" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticStyle: {
                                            height: "0px",
                                            width: "0px",
                                            "padding-right": "2px",
                                            "padding-bottom": "20px",
                                          },
                                          attrs: { text: "", icon: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.editItem(item)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticStyle: {
                                                "font-size": "18px",
                                              },
                                              attrs: {
                                                color: "grey lighten-1",
                                              },
                                            },
                                            [_vm._v("fas fa-pencil")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "v-alert",
                            {
                              attrs: {
                                slot: "no-results",
                                value: true,
                                color: "error",
                                type: "warning",
                              },
                              slot: "no-results",
                            },
                            [
                              _vm._v(
                                '\n                Your search for "' +
                                  _vm._s(_vm.search) +
                                  '" found no results.\n            '
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-tab-item",
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "", "align-center": "", "ml-1": "" } },
                    [
                      _c("v-flex", { attrs: { xs12: "" } }, [
                        _c("p"),
                        _c("h3", { staticClass: "headline mb-0" }, [
                          _vm._v("Server Log Levels"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs3: "", "pa-2": "" } },
                        [
                          _c("v-checkbox", {
                            attrs: {
                              label:
                                "Correlated (Requires collector v4.5 or newer)",
                              hint: "If checked, server logs will follow the Collector Log Levels scheme below",
                              "persistent-hint": "",
                            },
                            on: {
                              change: function ($event) {
                                _vm.changed = true
                              },
                            },
                            model: {
                              value: _vm.objCorrelated.value,
                              callback: function ($$v) {
                                _vm.$set(_vm.objCorrelated, "value", $$v)
                              },
                              expression: "objCorrelated.value",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.objCorrelated.value
                        ? _c(
                            "v-flex",
                            { attrs: { xs3: "", "pa-2": "" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  label: "Logging Level",
                                  hint: "Server logs will be at this selected level",
                                  "persistent-hint": "",
                                  items: [
                                    "Error",
                                    "Warn",
                                    "Info",
                                    "Debug",
                                    "Trace",
                                  ],
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.changed = true
                                  },
                                },
                                model: {
                                  value: _vm.objLogLevel.value,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.objLogLevel, "value", $$v)
                                  },
                                  expression: "objLogLevel.value",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.objCorrelated.value &&
                      _vm.objLogLevel.value == "Trace"
                        ? _c(
                            "v-flex",
                            { attrs: { xs3: "", "pa-2": "" } },
                            [
                              _c(
                                "v-alert",
                                { attrs: { value: true, type: "warning" } },
                                [
                                  _vm._v(
                                    "Please change the level back to Debug after your troubleshooting."
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.objCorrelated.value
                        ? _c(
                            "v-flex",
                            { attrs: { xs3: "", "pa-2": "" } },
                            [
                              _c(
                                "v-alert",
                                { attrs: { value: true, type: "warning" } },
                                [
                                  _vm._v(
                                    "If you have any Trace enabled, please set the level back to Debug after your troubleshooting."
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.changed
                        ? _c(
                            "v-flex",
                            { attrs: { xs3: "", "pa-2": "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "was-orange",
                                  attrs: {
                                    color: "primary",
                                    outlined: "",
                                    rounded: "",
                                  },
                                  on: { click: _vm.applyLogLevel },
                                },
                                [_vm._v("Apply Log Level Changes")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.objCorrelated.value
                        ? _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [_c("log-levels-subpanel")],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }